import React from 'react';
import { useLocale } from '../../hooks/useLocale';

export const legalLinks = [
  {
    name: 'Privacy Policy',
    href: 'https://jove.co/legal/privacy-policy',
  },
  {
    name: 'Cookie policy',
    href: 'https://jove.co/legal/cookie-policy',
  },
  {
    name: 'Terms and conditions',
    href: 'https://jove.co/legal/terms-and-conditions',
  },
  {
    name: 'Terms of Business Agreement',
    href: 'https://jove.co/legal/terms-of-business-agreement',
  },
  {
    name: 'Personal Data Retention Policy',
    href: 'https://jove.co/legal/personal-data-retention-policy',
  },
  {
    name: 'Complaints',
    href: 'https://jove.co/legal/complaints',
  },
];

export const socialLinks = [
  {
    name: 'Twitter',
    href: 'https://twitter.com/Jove51061635',
    icon: (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M20 2.80003C19.2483 3.12612 18.4534 3.34169 17.64 3.44003C18.4982 2.92735 19.1413 2.12081 19.45 1.17003C18.6436 1.65009 17.7608 1.98832 16.84 2.17003C16.2245 1.5026 15.405 1.05832 14.5098 0.906878C13.6147 0.755433 12.6945 0.905385 11.8938 1.33322C11.093 1.76105 10.4569 2.44256 10.0852 3.27086C9.71355 4.09917 9.62729 5.02742 9.84 5.91003C8.20943 5.82755 6.61444 5.40298 5.15865 4.66389C3.70287 3.9248 2.41885 2.88772 1.39 1.62003C1.02914 2.25019 0.839519 2.96385 0.84 3.69003C0.83872 4.36441 1.00422 5.02864 1.32176 5.62359C1.63929 6.21854 2.09902 6.72574 2.66 7.10003C2.00798 7.08229 1.36989 6.90733 0.8 6.59003V6.64003C0.804887 7.58492 1.13599 8.49912 1.73731 9.22799C2.33864 9.95687 3.17326 10.4557 4.1 10.64C3.74326 10.7486 3.37287 10.8058 3 10.81C2.74189 10.807 2.48442 10.7836 2.23 10.74C2.49391 11.5528 3.00462 12.2632 3.69107 12.7722C4.37753 13.2812 5.20558 13.5636 6.06 13.58C4.6172 14.7153 2.83588 15.3349 1 15.34C0.665735 15.3411 0.331736 15.3211 0 15.28C1.87443 16.4903 4.05881 17.1327 6.29 17.13C7.82969 17.146 9.35714 16.855 10.7831 16.2741C12.2091 15.6932 13.505 14.8339 14.5952 13.7465C15.6854 12.6591 16.548 11.3654 17.1326 9.94093C17.7172 8.51645 18.012 6.98975 18 5.45003C18 5.28003 18 5.10003 18 4.92003C18.7847 4.33484 19.4615 3.61745 20 2.80003Z"
          fill="white"
        />
        <path
          d="M20 2.80003C19.2483 3.12612 18.4534 3.34169 17.64 3.44003C18.4982 2.92735 19.1413 2.12081 19.45 1.17003C18.6436 1.65009 17.7608 1.98832 16.84 2.17003C16.2245 1.5026 15.405 1.05832 14.5098 0.906878C13.6147 0.755433 12.6945 0.905385 11.8938 1.33322C11.093 1.76105 10.4569 2.44256 10.0852 3.27086C9.71355 4.09917 9.62729 5.02742 9.84 5.91003C8.20943 5.82755 6.61444 5.40298 5.15865 4.66389C3.70287 3.9248 2.41885 2.88772 1.39 1.62003C1.02914 2.25019 0.839519 2.96385 0.84 3.69003C0.83872 4.36441 1.00422 5.02864 1.32176 5.62359C1.63929 6.21854 2.09902 6.72574 2.66 7.10003C2.00798 7.08229 1.36989 6.90733 0.8 6.59003V6.64003C0.804887 7.58492 1.13599 8.49912 1.73731 9.22799C2.33864 9.95687 3.17326 10.4557 4.1 10.64C3.74326 10.7486 3.37287 10.8058 3 10.81C2.74189 10.807 2.48442 10.7836 2.23 10.74C2.49391 11.5528 3.00462 12.2632 3.69107 12.7722C4.37753 13.2812 5.20558 13.5636 6.06 13.58C4.6172 14.7153 2.83588 15.3349 1 15.34C0.665735 15.3411 0.331736 15.3211 0 15.28C1.87443 16.4903 4.05881 17.1327 6.29 17.13C7.82969 17.146 9.35714 16.855 10.7831 16.2741C12.2091 15.6932 13.505 14.8339 14.5952 13.7465C15.6854 12.6591 16.548 11.3654 17.1326 9.94093C17.7172 8.51645 18.012 6.98975 18 5.45003C18 5.28003 18 5.10003 18 4.92003C18.7847 4.33484 19.4615 3.61745 20 2.80003Z"
          fill="#333333"
          fillOpacity="0.3"
        />
      </svg>
    ),
  },
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/joveinsurance ',
    icon: (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M18.9 0H1.1C0.808262 0 0.528473 0.115893 0.322183 0.322183C0.115893 0.528473 0 0.808262 0 1.1V18.9C0 19.0445 0.0284524 19.1875 0.0837326 19.321C0.139013 19.4544 0.220038 19.5757 0.322183 19.6778C0.424327 19.78 0.54559 19.861 0.679048 19.9163C0.812506 19.9715 0.955546 20 1.1 20H10.68V12.25H8.08V9.25H10.68V7C10.6261 6.47176 10.6885 5.93813 10.8627 5.43654C11.0369 4.93495 11.3188 4.47755 11.6885 4.09641C12.0582 3.71528 12.5068 3.41964 13.0028 3.23024C13.4989 3.04083 14.0304 2.96225 14.56 3C15.3383 2.99521 16.1163 3.03528 16.89 3.12V5.82H15.3C14.04 5.82 13.8 6.42 13.8 7.29V9.22H16.8L16.41 12.22H13.8V20H18.9C19.0445 20 19.1875 19.9715 19.321 19.9163C19.4544 19.861 19.5757 19.78 19.6778 19.6778C19.78 19.5757 19.861 19.4544 19.9163 19.321C19.9715 19.1875 20 19.0445 20 18.9V1.1C20 0.955546 19.9715 0.812506 19.9163 0.679048C19.861 0.54559 19.78 0.424327 19.6778 0.322183C19.5757 0.220038 19.4544 0.139013 19.321 0.0837326C19.1875 0.0284524 19.0445 0 18.9 0Z"
          fill="white"
        />
        <path
          d="M18.9 0H1.1C0.808262 0 0.528473 0.115893 0.322183 0.322183C0.115893 0.528473 0 0.808262 0 1.1V18.9C0 19.0445 0.0284524 19.1875 0.0837326 19.321C0.139013 19.4544 0.220038 19.5757 0.322183 19.6778C0.424327 19.78 0.54559 19.861 0.679048 19.9163C0.812506 19.9715 0.955546 20 1.1 20H10.68V12.25H8.08V9.25H10.68V7C10.6261 6.47176 10.6885 5.93813 10.8627 5.43654C11.0369 4.93495 11.3188 4.47755 11.6885 4.09641C12.0582 3.71528 12.5068 3.41964 13.0028 3.23024C13.4989 3.04083 14.0304 2.96225 14.56 3C15.3383 2.99521 16.1163 3.03528 16.89 3.12V5.82H15.3C14.04 5.82 13.8 6.42 13.8 7.29V9.22H16.8L16.41 12.22H13.8V20H18.9C19.0445 20 19.1875 19.9715 19.321 19.9163C19.4544 19.861 19.5757 19.78 19.6778 19.6778C19.78 19.5757 19.861 19.4544 19.9163 19.321C19.9715 19.1875 20 19.0445 20 18.9V1.1C20 0.955546 19.9715 0.812506 19.9163 0.679048C19.861 0.54559 19.78 0.424327 19.6778 0.322183C19.5757 0.220038 19.4544 0.139013 19.321 0.0837326C19.1875 0.0284524 19.0445 0 18.9 0Z"
          fill="#333333"
          fillOpacity="0.3"
        />
      </svg>
    ),
  },
];

const Footer = () => {
  const { t } = useLocale();
  return (
    <footer className="border-t-2 bg-black/75">
      <div className="mx-auto max-w-7xl items-center border-gray-100 px-4 py-6 sm:px-6 md:flex md:justify-between lg:px-8">
        <div className="flex justify-center space-x-6 md:order-2">
          {socialLinks.map((item) => (
            <a
              key={item.name}
              href={item.href}
              className="text-gray-400 hover:text-gray-500"
            >
              <span className="sr-only">{item.name}</span>
              <item.icon className="h-6 w-6" aria-hidden="true" />
            </a>
          ))}
        </div>
        <div className="mt-8 text-center md:order-1 md:mt-0">
          {legalLinks.map((link) => (
            <a
              href={link.href}
              key={link.name}
              className="ml-4 border-r border-r-white pr-4 text-sm leading-3 text-white first:ml-0 last:border-r-8 hover:underline"
            >
              {link.name}
            </a>
          ))}
          <p className="mt-1 text-center text-sm text-gray-400 sm:text-left">
            &copy; {new Date().getFullYear()} {t<string>('copyright')}
          </p>
        </div>
      </div>
      <p className="mt-1 pb-4 text-center text-sm text-gray-400">
        Jove Technology Limited is an appointed representative of Wrapper
        Limited, which is authorised and regulated by the Financial Conduct
        Authority.
      </p>
    </footer>
  );
};

export default Footer;
